import { DecisionReel } from '../features/landing/DecisionReel.jsx';
import { LandingShell } from '../features/landing/LandingShell.jsx';

/**
 * The web root: the individual pitch.
 *
 * One person, one decision, no more "you pick." A yes made by hand opens the
 * group half of the product, which is the bridge to `/groups` — see
 * `features/landing/GroupReveal.jsx`.
 *
 * Everything around the reel — the brand-green field, the wordmark, the
 * waitlist form — is `LandingShell`, shared with the group page so the two
 * cannot drift into looking like different companies.
 */
export function LandingScreen() {
  return (
    <LandingShell source="web-landing">
      <DecisionReel />
    </LandingShell>
  );
}
